import * as React from 'react';
import { memo } from 'react';
import cn from 'classnames';

import { Location } from '../../types';
import { Option as OptionType } from '../../../Autocomplete/types';
import { LocationMatchType } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';

interface Props {
	option: OptionType<Location>;
	onClick: (event: React.MouseEvent) => void;
}

const Option: React.FunctionComponent<Props> = memo(({ option, onClick }) => {
	const { Option: css } = useTheme('LocationAutocomplete');
	const { t } = useTranslation('LocationAutocomplete');
	const city = option.value;
	const match = city ? city.match : null;
	let meta: React.ReactNode;

	if (match) {
		if (
			(match.type === LocationMatchType.IataCode ||
				match.type === LocationMatchType.AlternateName ||
				match.type === LocationMatchType.Airport) &&
			match.name &&
			match.iata
		) {
			meta = (
				<div className={cn(css.meta, css.meta_gray)}>
					<span className={css.meta__label}>{match.name}</span>
					<span className={css.meta__value}>{match.iata}</span>
				</div>
			);
		} else if (match.type === LocationMatchType.ProbableName) {
			meta = <div className={cn(css.meta, css.meta_probable)}>{t('Perhaps you are looking for')}</div>;
		}
	}

	return (
		<div
			className={css.option}
			data-test-id="location-option"
			data-iata={city?.iata}
			data-city={option.label}
			onMouseDown={city ? onClick : null}
		>
			<div className={css.info}>
				<span className={css.label}>{option.label}</span>

				{city && (
					<span className={css.aside}>
						{city.stopPointsCount > 0 && (
							<span className={css.stops}>
								{city.stopPointsCount}{' '}
								{t('Stop', {
									count: city.stopPointsCount
								})}
							</span>
						)}

						<span className={css.code}>{city.iata}</span>
					</span>
				)}
			</div>

			{meta}
		</div>
	);
});

export default Option;
